module.exports = __webpack_public_path__ + "img/skip-forward-fill.7b0a328a.svg";